/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, November 11th 2021, 10:55:05 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup, { RadioGroupProps } from "@mui/material/RadioGroup";
import Radio, { RadioProps } from "@mui/material/Radio";
import { OSFormInputProps, useControlledInput } from "ui-widgets/forms";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";

type RadioFormInputProps<T> = OSFormInputProps<T> &
  RadioProps &
  RadioGroupProps & { options: { [key: string]: any }; defaultValue?: string };

export const RadioFormInput = <T,>(props: RadioFormInputProps<T>) => {
  const {
    controlledProps,
    field: { onChange, value },
  } = useControlledInput<T>(props);

  return (
    <APIFormInputErrorWrapper {...props}>
      <CustomInputValidationErrorWrapper {...props}>
        <HelperTextInputWrapper helperText={props.helperText}>
          <FormControl component="fieldset">
            {props.label && <FormLabel component="legend">{props.label}</FormLabel>}
            <RadioGroup
              row
              aria-label={props["aria-label"]}
              name="row-radio-buttons-group"
              {...controlledProps}
              value={`${value}`} // Value for radio group and FormControlLabel are compared as strings so we must use template literal strings in case any values are integers.
              onChange={onChange}
            >
              {Object.keys(props.options).map((k, index) => (
                <FormControlLabel key={index} value={`${k}`} control={<Radio />} label={props.options[k]} />
              ))}
            </RadioGroup>
          </FormControl>
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
